import React from "react";
import MuiCard, { CardProps as MuiCardProps } from "@mui/material/Card";
import MuiCardActions from "@mui/material/CardActions";
import MuiCardContent from "@mui/material/CardContent";
import Button, { ButtonProps } from "@mui/material/Button/Button";
import { map } from "lodash";

type CardProps = MuiCardProps & {
  actions?: ButtonProps[];
  children: React.ReactNode;
};

export function Card({ actions, children, ...rest }: CardProps) {
  return (
    <MuiCard style={{ flexGrow: 1 }} {...rest}>
      <MuiCardContent>{children}</MuiCardContent>
      {actions && Array.isArray(actions) && (
        <MuiCardActions>
          {map(actions, (action, index) => (
            <Button key={index.toString()} {...action} />
          ))}
        </MuiCardActions>
      )}
    </MuiCard>
  );
}
